import { useEffect, useRef, useState } from 'react';

// Last start timestamp
const ST_START_TIME = 'CACHED_START_TIME';
// Total milliseconds before last start
const ST_TOTAL_MILLISECONDS = 'CACHED_MILLISECONDS';
// Milliseconds count after last start
const ST_CURRENT_MILLISECONDS = 'CACHED_CURRENT_MILLISECONDS';

const getCachedMilliseconds = () => {
  const time = window.localStorage.getItem(ST_TOTAL_MILLISECONDS);

  return time ? parseInt(time, 10) : 0;
};

const getCurrentMilliseconds = () => {
  const time = window.localStorage.getItem(ST_CURRENT_MILLISECONDS);

  return time ? parseInt(time, 10) : 0;
};

const setStartTime = () => {
  const now = new Date().getTime();
  window.localStorage.setItem(ST_START_TIME, now);
};

const clearCachedTimer = () => {
  window.localStorage.removeItem(ST_START_TIME);
  window.localStorage.removeItem(ST_TOTAL_MILLISECONDS);
  window.localStorage.removeItem(ST_CURRENT_MILLISECONDS);
};

// updates cached time and clear current counting
// returns cached time for setting it on page load
const suspendTimer = () => {
  let cachedMs = getCachedMilliseconds();
  const currentMs = getCurrentMilliseconds();

  cachedMs += currentMs;

  window.localStorage.setItem(ST_TOTAL_MILLISECONDS, cachedMs);

  window.localStorage.removeItem(ST_START_TIME);
  window.localStorage.removeItem(ST_CURRENT_MILLISECONDS);

  return Math.floor(cachedMs / 1000);
};

// calculates elapsed time after last start and caches it in localStorage
// returns total recording elapsed time
const runTimer = () => {
  const cachedMs = getCachedMilliseconds();

  const cachedStartTime = window.localStorage.getItem(ST_START_TIME);
  const startTime = new Date(parseInt(cachedStartTime, 10)).getTime();
  const now = new Date().getTime();
  const currentMs = now - startTime;
  const newTime = cachedMs + currentMs;

  window.localStorage.setItem(ST_CURRENT_MILLISECONDS, currentMs);

  return Math.floor(newTime / 1000);
};

export function useTicker({ active, suspended }) {
  const [time, setTime] = useState(0);
  const interval = useRef();

  useEffect(() => {
    if (!active && !suspended) {
      clearInterval(interval.current);
      interval.current = null;
      clearCachedTimer();
      setTime(0);
    } else if (suspended) {
      clearInterval(interval.current);
      interval.current = null;
      const cachedTime = suspendTimer();
      setTime(cachedTime);
    } else {
      if (!window.localStorage.getItem(ST_START_TIME)) {
        setStartTime();
      }

      interval.current = setInterval(() => {
        setTime(runTimer());
      }, 500);
    }

    return () => clearInterval(interval.current);
  }, [active, suspended]);

  return time;
}
